<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<header class="slds-page-header slds-has-bottom-magnet">
  <div class="slds-page-header__row">
    <div class="slds-page-header__col-title">
      <div class="slds-media">
        <div class="slds-media__figure">
          <span class="slds-avatar slds-avatar_medium">
            <img alt="Capture Time" src="/assets/accorto/timeKeeper-100.svg">
          </span>
        </div>
        <div class="slds-media__body">
          <div class="slds-page-header__name">
            <div class="slds-page-header__name-title">
              <h1>
                <span class="slds-page-header__title slds-truncate">Time Keeper</span>
              </h1>
            </div>
          </div>
          <p class="slds-page-header__name-meta"></p>
        </div>
      </div>

    </div>
    <div class="slds-page-header__col-actions">
      <div class="slds-page-header__controls">
        <div class="slds-page-header__control">
          <ul class="slds-button-group-list">
            <li>
              <button class="slds-button slds-button_neutral">New
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- status -->
  <div class="slds-page-header__row">
    <div class="slds-page-header__col-meta">
      <acc-status-line [error]="error" [message]="message"></acc-status-line>
    </div>
  </div>
</header>

<section class="slds-card slds-p-horizontal_small slds-m-top_small slds-is-relative">

  <acc-spinner *ngIf="busy"></acc-spinner>
</section>
